var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{class:_vm.disabled ? 'ctnrDis' : 'ctnr'},[_vm._v(_vm._s(_vm.text)+" "),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"click":_vm.action}}),_c('span',{class:_vm.disabled ? 'checkmarkDis' : 'checkmark'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }